<template>
  <div >
    <DxDataGrid
      id="BasicDataGrid"
      :ref="gridRef"
      :keyExpr="dataGridKey"
      :data-source="dataSource"
      :cache-enabled="true"
      @editing-start="setEditing(true)"
      @row-updated="setEditing(false)"
      :show-row-lines="showRowLines"
      @selection-changed="onSelectionChanged"
      :show-column-lines="showColumnLines"
      :row-alternation-enabled="alternateRowEnabled"
      :allow-column-resizing="true"
      :column-resizing-mode="columnResizingMode" 
      :column-min-width="25"
      :remoteOperations="true"
      :on-cell-prepared="onCellPrepared"
      :no-data-text="noDataText"
      width="100%"
      :height="height"
      :show-borders="true"
      :column-auto-width="true"
    >
      <DxExport :enabled="allowExport" />
      <DxSelection
        v-if="multiSelect"
        select-all-mode="allPages"
        show-check-boxes-mode="always"
        mode="multiple"
        maxWidth="25px"
      />
      <DxScrolling />
      <DxSearchPanel id="BasicDataGridSearch" :visible="searchEntireGrid"/>
      <DxFilterRow   :showOperationChooser="showColumnSearchIcon" :visible="searchByColumn"/>
      <DxHeaderFilter :visible="filterByColumn" />
      <DxFilterPanel :visible="advancedFilter"/>
      <DxPaging :page-index="0" :page-size="itemsPerPage"/>
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="itemsPerPageOptions"
        :show-info="true"
      />
      <!-- <DxGroupPanel :visible="true"/>
      <DxGrouping :auto-expand-all="false"/> -->
      <DxEditing
        :allow-updating="allowEditing"
        mode="cell"
      />
      <DxColumn
          v-for="(column,index) in columns"
          :key="index"
          :width="column.width"
          :max-width="column.maxWidth"
          :data-field="column.value"
          :data-type="column.dataType"
          :caption="column.text"
          :customize-text="column.customizeText || null"
          header-cell-template="title-header"
          cell-template="grid-cell"
      />

      <DxColumn
        v-if="iconActions.length"
        :min-width="75"
        caption="Actions"
        type="buttons"
        alignment="right"
      >
        <DxButton v-for="(icon, index) in iconActions" :key="icon.hint + index"
                  :text="icon.hint"
                  :icon="icon.icon"
                  :visible="icon.visible"
                  :hint="icon.hint"
                  :on-click="iconClickEmit" />
      </DxColumn>
<!--      <DxColumn caption="Actions"-->
<!--                cell-template="actions-cell-template"-->
<!--                :min-width="75"-->
<!--                v-if="iconActions.length"/>-->
      <!-- <template  #grid-cell-buttons="{ data }">
          <div :style="{textAlign: 'right'}">{{ data.value }}</div>
      </template> -->
      <template #title-header="{ data }">
        <div class="header" style="fontSize: 16px">{{ data.column.caption }}</div>
      </template>
      <template  #grid-cell="{ data }">
          <div class="cell" style="fontSize: 14px">{{ data.text }}</div>
      </template>
    </DxDataGrid>
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>{{currentCellToolTip}}</div>
      </div>
    </dx-tooltip>
  </div>
</template>
<script>

import DxDataGrid, {DxSelection, DxExport, DxEditing, DxScrolling, DxColumn, DxFilterRow, DxSearchPanel, DxFilterPanel, DxHeaderFilter, DxPaging, DxPager, DxButton}       from 'devextreme-vue/data-grid';

import DxTooltip from "devextreme-vue/tooltip"
import { on, off } from "devextreme/events";
// import { exportDataGrid } from 'devextreme/excel_exporter';
// import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

export default {
  name: 'BasicDataGrid',
  props: {
    //Array of Objects containing the data used to populate the grid
    //Template: [{city: 'Atlanta', state: 'GA', phone: '(404)854-5859'}]
    dataSource:{
      type: [Object, Array],
      default:() => {}
    },
    dataGridKey: {
      type: String,
      default: 'Id'

    },
    //Headers used for mapping data to columns columns =[{text: 'Header Label', value: 'Column Value', width: '100px', dataType: 'Number'}], value should match datasource property
    columns:{
      type: Array,
      default:[]
    },
    showColumnSearchIcon: {
      type: Boolean,
      default: true,
    },
    gridRef: {
      type: String, 
      default: 'Grid'
    },
    allowExport: {
      type: Boolean,
      default: false
    },
    showColumnLines:{
      type: Boolean,
      default: false
    },
    showRowLines:{
      type: Boolean,
      default: true
    },
    alternateRowEnabled:{
      type: Boolean,
      default: true
    },
    searchEntireGrid:{
      type: Boolean,
      default: true
    },
    searchByColumn: {
      type: Boolean,
      default: true
    },
    filterByColumn:{
      type: Boolean,
      default: true
    },
    advancedFilter:{
      type: Boolean,
      default: false
    },
    itemsPerPage:{
      type: Number,
      default: 50
    },
    itemsPerPageOptions:{
      type: Array,
      default: () => [50, 100, 200],
    },
    noDataText: {
      type: String,
      default: 'No Data Available'
    },
    //Options for ColumnResizing 'nextColumn' and 'widget'
    columnResizingMode: {
      type: String,
      default: 'widget'
    },
    multiSelect:{
      type: Boolean,
      default: true
    },
    // cellFontSize: {
    //   type: String,
    //   default: '12px'
    // },
    smartCatalogSearchGrid: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "600px"
    },
    // headerFontSize: {
    //   type: String,
    //   default: '16px'
    // },
    allowEditing: {
      type: Boolean,
      default: false
    },
    actions: {
      // Template: [{hint: 'Delete, icon: 'trash', emit: 'value you would like to emit'}] emit will return the event
      // must have a hint property to trigger emit events 
      // For icon options visit:
      // https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/buttons/#icon
      // or for built in devExtreme icon Library
      // https://js.devexpress.com/Documentation/Guide/Themes_and_Styles/Icons/#Built-In_Icon_Library
      type: Array,
      default: () => [],
      
    },
  },
  components: {
    DxTooltip,
    DxDataGrid, 
    DxColumn,
    DxFilterRow,
    DxSearchPanel,
    DxFilterPanel,
    DxHeaderFilter,
    DxPaging,
    DxExport,
    DxPager,
    DxSelection,
    DxScrolling,
    DxEditing,
    DxButton
  },
  data() {
    return {
      currentCellToolTip: '',
      tooltipRefName: 'tooltip',
      iconActions: [],
      editing: false,
      selectedOrders: null,
    };
  },
  methods: {
    onCellPrepared(e) {
      if (e.rowType === "header" && e.column.caption) {
        var self = this;
        on(e.cellElement, "mouseover", arg => {
            self.currentCellToolTip = e.column.caption;
            self.$refs[self.tooltipRefName].instance.show(arg.target);
        });
        on(e.cellElement, "mouseout", arg => {
          self.$refs[self.tooltipRefName].instance.hide();
        });
      }
    },
    setEditing(bool){
      this.editing = bool;
    },
    onSelectionChanged(e){
      this.$emit('selectedRowsChanged', e.selectedRowsData)
    },
    iconClickEmit(e) {
      // event returned does not include specific action pressed, DevExtreme sets the target title to the hint value given.
      let actionIndex = this.iconActions.map(action => action.hint).indexOf(e.event.target.title)
      let emitterValue = this.iconActions[actionIndex].emit
      this.$emit(emitterValue, e)
    },
    productHasImage(e) {
        return e.row.data.ThumbnailURL;
    },
    // onExporting(e) {
    //   const workbook = new ExcelJS.Workbook();
    //   const worksheet = workbook.addWorksheet('Main sheet');
    //   exportDataGrid({
    //     component: e.component,
    //     worksheet: worksheet,
    //     customizeCell: function(options) {
    //       const excelCell = options;
    //       excelCell.font = { name: 'Arial', size: 12 };
    //       excelCell.alignment = { horizontal: 'left' };
    //     }
    //   }).then(function() {
    //     workbook.xlsx.writeBuffer()
    //       .then(function(buffer) {
    //           saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    //       });
    //   });
    //   e.cancel = true;
    // }

  },
  // computed: {
  //   dataGrid(){
  //     return this.$refs.gridRef.instance
  //   }
  // },
  created(){
    // this.iconActions = ['edit']
        

    if(this.actions.length > 0){
      this.actions.forEach(action => {
        this.iconActions.push({
          ...action,
          onClick: this.iconClickEmit
        })
      })
    }
    if(this.smartCatalogSearchGrid){
      this.iconActions.forEach((icon,index) => {
        if(icon.hint === 'image'){
          icon.visible = this.productHasImage
        }
      })
    }
    
  }
};
</script>
<style lang="scss" scoped>
  .header {
    color: $primary;
  }
  .cell {
    color: $ss_grey1;
  }
</style>
